module.exports = __webpack_public_path__ + "media/social/social-4-b0eaa233.jpg";